const RejectIcon = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2188 7.40625H4.78125C4.488 7.40625 4.25 7.16878 4.25 6.875C4.25 6.58175 4.488 6.34375 4.78125 6.34375H12.2188C12.512 6.34375 12.75 6.58175 12.75 6.875C12.75 7.16878 12.512 7.40625 12.2188 7.40625ZM11.1562 10.5938H5.84375C5.5505 10.5938 5.3125 10.3563 5.3125 10.0625C5.3125 9.76872 5.5505 9.53125 5.84375 9.53125H11.1562C11.4495 9.53125 11.6875 9.76872 11.6875 10.0625C11.6875 10.3563 11.4495 10.5938 11.1562 10.5938ZM8.5 0.5C3.80587 0.5 0 3.83041 0 7.9375C0 10.2851 1.24578 12.3756 3.1875 13.7382V17.5L6.91103 15.2406C7.42635 15.3256 7.95653 15.375 8.5 15.375C13.1941 15.375 17 12.0451 17 7.9375C17 3.83041 13.1941 0.5 8.5 0.5Z"
      fill="#E2341D"
    />
  </svg>
);

export default RejectIcon;
